import React, { useEffect } from 'react';
import '../../css/App.css';
import '../../css/OrstedSans.css';
import { useDispatch, useSelector } from 'react-redux';
import { setPlaying, clearChapterActionsThunk, toggleInfoPopupThunk, changeStoryAction } from '../../store/StoryStore';
import Menu from '../Menu';
import SafetyInduction from './SafetyInduction';


const ShortInteractiveStory = () => {
    const dispatch = useDispatch();
    const storyState = useSelector(state => state.storyState);

    // Find the default storyId for 'Kort sikkerhedsintroduktion'
    const defaultStory = (storyState.stories && storyState.stories.length > 0 && storyState.stories[0].chapters.length !== 0)
        ? storyState.stories.find(s => s.cultureCode === 'da-DK' && s.category === 'Kort sikkerhedsintroduktion')
        : undefined;
    const defaultStoryId = defaultStory ? defaultStory.id : undefined;

    useEffect(() => {
        if (defaultStoryId !== undefined) {
            dispatch(setPlaying(false));
            dispatch(clearChapterActionsThunk());
            dispatch(toggleInfoPopupThunk(undefined, false));
            dispatch(changeStoryAction({ storyId: defaultStoryId }));
        }
    }, [dispatch, defaultStoryId]);

    return (
        <div className="App">
            <Menu />
            <SafetyInduction
                isSafetyInduction={false}
                isShortSafetyInduction={true}
                languageButtonIsVisible={true}
            />
        </div>
    );
}

export default ShortInteractiveStory;